import React, { Component } from 'react';

class ScrollTop extends Component {
  componentDidMount() {
    const jquery = window.$;
    const scrollTop = jquery(".scrollTop");
    jquery(window).scroll(() => {
      let topPos = jquery(window).scrollTop();

      if (topPos > 200) {
        jquery(scrollTop).css("opacity", "1");
      }
      else {
        jquery(scrollTop).css("opacity", "0");
      }
    });

    jquery(scrollTop).click(() => {
      jquery('html, body').animate({
        scrollTop: 0
      }, 800);

      return false;
    });
  }

  render() {
    return (
      <div id="stop" className="scrollTop">
        <span><a id="scroll-top"><i className="fa fa-arrow-up"></i></a></span>
      </div>
    );
  }
}

export default ScrollTop;
